import {TextLayoutPage} from '../components/layout/textLayoutPage';
import client from '../apollo-client';
import {
  GET_ALL_GUIDES,
} from '../lib/api/graphql/query';
import SupportColumn from '../components/support/supportColumn';
import _ from 'lodash';
import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import {useTranslation} from 'next-i18next';
import {getStrapiLocale} from '../lib/utils/locationUtils';

export default function Support({allGuides}) {

  const {t: translateSiteMeta} = useTranslation('site-meta');
  const {t: translateCommon} = useTranslation('common');

  const modelS = _.groupBy(allGuides.modelS.guides, 'shortTitle');
  const model3 = _.groupBy(allGuides.model3.guides, 'shortTitle');
  const modelX = _.groupBy(allGuides.modelX.guides, 'shortTitle');
  const modelY = _.groupBy(allGuides.modelY.guides, 'shortTitle');

  const installationVideoString = translateCommon('INSTALLATION_VIDEO');
  const allModelsString = translateCommon('ALL_MODELS');
  const obdCableInstallationString = translateCommon('OBD_CABLE_INSTALLATION');

  const obd2InstallationVideo = {
    '__typename': 'ComponentComplexProductInstallationManual',
    'id': '999999',
    'link': 'https://www.youtube.com/watch?v=1wo98ayc8Mw',
    'type': 'VIDEO_URL',
    'subtitle': installationVideoString,
    'pdf': null,
    'shortTitle': 'AMPTech App',
  };

  const allModels = {};
  allModels[obdCableInstallationString] = [obd2InstallationVideo];

  return <TextLayoutPage title={translateSiteMeta('SUPPORT')}
                         description={translateSiteMeta(
                             'SUPPORT_META_DESCRIPTION')}>

    <div
        className={'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-2 md:gap-4 lg:gap-8'}>

      {allGuides.modelS.guides.length > 0 &&
      <SupportColumn title={'Model S'} manuals={modelS}
                     thumbnail={allGuides.modelS.thumbnail}/>}

      {allGuides.model3.guides.length > 0 &&
      <SupportColumn title={'Model 3'} manuals={model3}
                     thumbnail={allGuides.model3.thumbnail}/>}
      {allGuides.modelX.guides.length > 0 &&
      <SupportColumn title={'Model X'} manuals={modelX}
                     thumbnail={allGuides.modelX.thumbnail}/>}

      {allGuides.modelY.guides.length > 0 &&
      <SupportColumn title={'Model Y'} manuals={modelY}
                     thumbnail={allGuides.modelY.thumbnail}/>}

      <SupportColumn title={allModelsString} manuals={allModels}
                     thumbnail={{
                       formats: {
                         small: {url: 'https://amptech-spaces.fra1.digitaloceanspaces.com/strapi/b9869c6234dba40cc33d8808a1f9b6c4.png'},
                       },
                       alt: 'AMPTech Logo',
                       height: 289,
                       width: 829,
                     }}/>

    </div>

  </TextLayoutPage>;
}

export async function getStaticProps({locale, defaultLocale}) {

  const _locale = getStrapiLocale(locale);

  const allMacroProductsResponse = await client.query(
      {
        query: GET_ALL_GUIDES,
        variables: {locale: _locale},
      },
  );

  let macroProducts;
  if (allMacroProductsResponse.data !== null)
    macroProducts = allMacroProductsResponse.data.macroProducts;

  const allGuides = {
    modelS: {guides: [], thumbnail: null},
    model3: {guides: [], thumbnail: null},
    modelX: {guides: [], thumbnail: null},
    modelY: {guides: [], thumbnail: null},
  };

  for (let product of macroProducts) {

    if (!!product.category) {

      const {title: categoryTitle, thumbnail} = product.category;
      const {extra, shortTitle} = product;

      for (let extraItem of extra) {

        const {__typename: extraType} = extraItem;
        if (extraType.toLowerCase().includes('manual')) {

          const manualItem = {
            ...extraItem,
            shortTitle,
          };

          switch (categoryTitle.slice(-1).toLowerCase()) {

            case 's':
              allGuides.modelS.guides.push(manualItem);
              allGuides.modelS.thumbnail = thumbnail;
              break;
            case '3':
              allGuides.model3.guides.push(manualItem);
              allGuides.model3.thumbnail = thumbnail;
              break;
            case 'x':
              allGuides.modelX.guides.push(manualItem);
              allGuides.modelX.thumbnail = thumbnail;
              break;
            case 'y':
              allGuides.modelY.guides.push(manualItem);
              allGuides.modelY.thumbnail = thumbnail;
              break;

          }

        }
      }
    }

  }

  return {
    props: {
      allGuides: allGuides || {},
      ...(await serverSideTranslations(locale,
          ['common', 'pages', 'products', 'site-meta', 'menu'])),
    },
  };
}
